import {useKeycloak} from "@react-keycloak/web"

export const useKeyCloakLogout = (_: string) => {
    const {keycloak} = useKeycloak()

    const logout = () => {
        sessionStorage.clear()
        const columnView = localStorage.getItem("columnView")
        localStorage.clear()
        localStorage.setItem("columnView", columnView + "")
        keycloak.logout()
    }

    return {
        logout
    }
}
